import React, { FC, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { intersection, not } from '../../logics';
import CustomList from './CustomList';
import useStyles from './styles';

interface ICustomTransferList {
  left?: any[];
  onLeft?: (values: any[]) => void;
  right?: any[];
  onRight?: (values: any[]) => void;
  getOptionLabel?: (item: any) => string;
  loadingLeft?: boolean;
  loadingRight?: boolean;
}

const CustomTransferList: FC<ICustomTransferList> = (props) => {
  const {
    left = [],
    right = [],
    onLeft = () => {},
    onRight = () => {},
    getOptionLabel,
    loadingLeft = false,
    loadingRight = false,
  } = props;

  const classes = useStyles();

  const [checked, setChecked] = useState<any[]>([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleCheckedRight = () => {
    onRight(right.concat(leftChecked));
    onLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    onLeft(left.concat(rightChecked));
    onRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  return (
    <Grid item container spacing={2} justify="center">
      <Grid item xs={12} sm={5}>
        <CustomList
          title="Choix"
          items={left}
          values={checked}
          onChange={(values: any[]) => setChecked(values)}
          getOptionLabel={getOptionLabel}
          loading={loadingLeft}
          emptyMessage="Déjà ajouté ou vide"
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="Déplacer vers la droite">
            &gt;
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="Déplacer vers la gauche">
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={5}>
        <CustomList
          title="Choisis"
          items={right}
          values={checked}
          onChange={(values: any[]) => setChecked(values)}
          getOptionLabel={getOptionLabel}
          loading={loadingRight}
        />
      </Grid>
    </Grid>
  );
};

export default CustomTransferList;
